import { Alert, Anchor, Badge, Button, Group, Table, Text } from '@mantine/core';
import { IconAlertTriangle, IconPlus } from '@tabler/icons-react';
import { Link, useNavigate } from 'react-router-dom';

import { useSegments } from '../api/hooks';
import { DataState } from '../components/DataState';
import { PageHeader } from '../components/PageHeader';
import { fmtNumber, fmtRelative } from '../theme/format';

export function SegmentsPage() {
  const { data, isLoading, error } = useSegments();
  const navigate = useNavigate();

  return (
    <>
      <PageHeader
        title="Segments"
        description="Stored predicates, evaluated when you use them. A segment is always current — there is nothing to refresh."
        action={
          <Button leftSection={<IconPlus size={16} />} onClick={() => navigate('/segments/new')}>
            New segment
          </Button>
        }
      />

      <DataState
        loading={isLoading}
        error={error}
        empty={!data?.length}
        emptyTitle="No segments yet"
        emptyDescription="Build one from traits, behaviour, device state, or consent."
        action={<Button onClick={() => navigate('/segments/new')}>Build a segment</Button>}
      >
        <Table.ScrollContainer minWidth={720}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Name</Table.Th>
                <Table.Th>Definition</Table.Th>
                <Table.Th ta="right">Members</Table.Th>
                <Table.Th>Updated</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {data?.map((s) => (
                <Table.Tr key={s.id}>
                  <Table.Td>
                    <Anchor component={Link} to={`/segments/${s.id}`} fw={500} size="sm">
                      {s.name}
                    </Anchor>
                    {s.description && (
                      <Text size="xs" c="dimmed">{s.description}</Text>
                    )}
                  </Table.Td>
                  <Table.Td maw={380}>
                    {s.compile_error ? (
                      <Alert
                        color="red" variant="light" p={6}
                        icon={<IconAlertTriangle size={14} />}
                      >
                        <Text size="xs">{s.compile_error}</Text>
                      </Alert>
                    ) : (
                      <Text size="xs" c="dimmed" ff="monospace" lineClamp={2}>
                        {s.summary}
                      </Text>
                    )}
                  </Table.Td>
                  <Table.Td ta="right">
                    {s.member_count === null ? (
                      <Text size="xs" c="dimmed">not counted</Text>
                    ) : (
                      fmtNumber(s.member_count)
                    )}
                  </Table.Td>
                  <Table.Td>
                    <Group gap={6}>
                      <Text size="xs" c="dimmed">{fmtRelative(s.updated_at)}</Text>
                      {s.kind === 'materialized' && (
                        <Badge size="xs" variant="light">materialized</Badge>
                      )}
                    </Group>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </DataState>
    </>
  );
}
